import { useMemo } from "react";
import { useTypedSelector } from "../store/reducers/use-typed-selector";

import { Language } from "../types/working-model";
import TranslateLangs from './translate-langs.json';

export const useDefaultEventLanguage = (): Language => {
	const eventSettings = useTypedSelector(state => state.CreateEventReducer.workingEvent?.settings)

	return useMemo(() => {
		const { i18n } = eventSettings ?? {};
		const defaultEventLanguageCode = i18n?.base;

		if (!defaultEventLanguageCode) {
			return TranslateLangs[0];
		}

		const matchingLang = TranslateLangs.find(lang => lang.code === defaultEventLanguageCode);
		return matchingLang ?? TranslateLangs[0];
	}, [eventSettings]);
};